import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, MapPin } from 'lucide-react';

const ProjectsSection = () => {
  const projects = [
    {
      title: 'Modern Living Room Refresh',
      location: 'Manhattan, NY',
      category: 'Living Room',
      image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=80',
      size: 'large',
    },
    {
      title: 'Accent Wall Installation',
      location: 'Brooklyn, NY',
      category: 'Feature Wall',
      image: 'https://images.unsplash.com/photo-1615529328331-f8917597711f?auto=format&fit=crop&w=800&q=80',
      size: 'small',
    },
    {
      title: 'Luxury Bedroom Styling',
      location: 'Upper East Side, NY',
      category: 'Bedroom',
      image: 'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=800&q=80',
      size: 'small',
    },
    {
      title: 'Contemporary Home Office',
      location: 'SoHo, NY',
      category: 'Office',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80',
      size: 'medium',
    },
    {
      title: 'Minimalist Dining Space',
      location: 'Queens, NY',
      category: 'Dining Room',
      image: 'https://images.unsplash.com/photo-1617806118233-18e1de247200?auto=format&fit=crop&w=800&q=80',
      size: 'medium',
    },
  ];

  return (
    <section
      data-testid="projects-section"
      className="section-padding bg-white"
    >
      <div className="container-main">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-[#C5A065] mb-4 block">
              Our Portfolio
            </span>
            <h2
              data-testid="projects-title"
              className="font-heading text-3xl md:text-4xl text-[#2D2D2D]"
            >
              Featured Projects
            </h2>
          </div>
          <Link to="/projects" className="mt-6 md:mt-0">
            <Button
              data-testid="projects-view-all-btn"
              variant="ghost"
              className="text-[#C5A065] hover:text-[#b08d52] p-0"
            >
              View All Projects <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>

        {/* Projects Grid - Asymmetric Layout */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {/* Large Featured Project */}
          <div
            data-testid="project-card-0"
            className="project-card md:col-span-7 aspect-[4/3] md:aspect-auto md:h-[500px] rounded-sm overflow-hidden"
          >
            <img
              src={projects[0].image}
              alt={projects[0].title}
              className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
            />
            <div className="overlay" />
            <div className="content text-white">
              <span className="text-xs uppercase tracking-wider text-[#C5A065] mb-2 block">
                {projects[0].category}
              </span>
              <h3 className="font-heading text-2xl mb-2">{projects[0].title}</h3>
              <div className="flex items-center gap-2 text-sm text-white/80">
                <MapPin className="w-4 h-4" />
                {projects[0].location}
              </div>
            </div>
          </div>

          {/* Stacked Projects */}
          <div className="md:col-span-5 grid grid-rows-2 gap-6">
            {projects.slice(1, 3).map((project, index) => (
              <div
                key={index + 1}
                data-testid={`project-card-${index + 1}`}
                className="project-card aspect-[4/3] md:aspect-auto rounded-sm overflow-hidden"
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                />
                <div className="overlay" />
                <div className="content text-white">
                  <span className="text-xs uppercase tracking-wider text-[#C5A065] mb-2 block">
                    {project.category}
                  </span>
                  <h3 className="font-heading text-xl mb-2">{project.title}</h3>
                  <div className="flex items-center gap-2 text-sm text-white/80">
                    <MapPin className="w-4 h-4" />
                    {project.location}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom Row */}
          {projects.slice(3).map((project, index) => (
            <div
              key={index + 3}
              data-testid={`project-card-${index + 3}`}
              className="project-card md:col-span-6 aspect-[4/3] rounded-sm overflow-hidden"
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
              />
              <div className="overlay" />
              <div className="content text-white">
                <span className="text-xs uppercase tracking-wider text-[#C5A065] mb-2 block">
                  {project.category}
                </span>
                <h3 className="font-heading text-xl mb-2">{project.title}</h3>
                <div className="flex items-center gap-2 text-sm text-white/80">
                  <MapPin className="w-4 h-4" />
                  {project.location}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
